import { Component,ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { ViewWillEnter,IonContent  } from "@ionic/angular";
import { WebOrderService } from '../../services/web-order.service';
import { ToasterService } from "../../../../common/services/toaster.service";
import { RequestParams } from '../../../../common/rest-api/models/request-params';
@Component({
  selector: 'app-web-emblems-admin-page',
  templateUrl: 'web-emblems-admin.page.html',
  styleUrls: [
    './web-emblems-admin.page.scss',
  ]
})
export class WebEmblemsAdminPage {
  settingsFields:any[];
  systemSetting:any[];
  rows:any;
  totalPages:number;
  currPage:number;
  currentRoute: string;
  customerCode:string;
  requestParams: any;
  totalElements: number = 0;
  pageSize: number;
  isVisible:boolean=false;
  @ViewChild('content', { static: false }) content: IonContent;
  loading:boolean=true ;
    constructor(
        private webOrderService: WebOrderService,
        private toasterService: ToasterService,
        private router:Router
      ) { 
  this.currentRoute = null;
    }
 ngOnInit() {
    this.currentRoute = this.router.url;
  }
  async ionViewWillEnter():Promise<void> {
}
  getWebProduct(){
  this.isVisible=true;
    this.loadData();
  }
  async loadData() {
    this.rows = [];
    this.currPage = 1;
    this.pageSize = 500;
    this.requestParams = new RequestParams();
     delete this.requestParams.filters.ProductCode;
    this.loading=false;
    var products=await this.webOrderService.getWebEmblemsAdmin(this.customerCode);
      
    if(products!=null){
      this.totalElements = products.totalRecords;
      this.totalPages = products.totalPages;
      this.rows = products.results;
      }
    this.loading=true;

    }
  toggleSelection(setting: any, event: any) {
    setting.data = event.detail.checked;
  }

   async setPage(page): Promise<void> {
    this.loading=false;
    this.currPage = page + 1;
    await this.loadData();
    this.content.scrollToTop(500);
     this.loading=false;
  }
}